import httpClient from './httpClient';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

class ApiWrapper {
  constructor() {
    httpClient.defaults.headers.common['Init-Data'] = Telegram.WebApp.initData;
    // httpClient.defaults.headers.common['Init-Data'] = "query_id=AAGi4tkVAAAAAKLi2RXW9G_Y&user=%7B%22id%22%3A366600866%2C%22first_name%22%3A%22Denys%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22realdenys%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%7D&auth_date=1729781824&hash=df6acfc179a614717e573f04040a8f1d5b661a8e1a55dd7c61e0ee126cf73f16";
  }

  public async get<T>(endpoint: string, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await httpClient.get(endpoint, config);
    return response.data;
  }

  public async post<T, D = any>(endpoint: string, data?: D, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await httpClient.post(endpoint, data, config);
    return response.data;
  }

  public async put<T, D = any>(endpoint: string, data?: D, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await httpClient.put(endpoint, data, config);
    return response.data;
  }
}

export default ApiWrapper;
